import { useContext } from 'react';
import { AuthContextFirebase } from '../Authenticate/AuthenticateFirebase';
import saveTextToFile from '../../utils/saveTextToFile';
import { trackEvent } from '../../utils/tracking';

const useDownloadConfigIOS = (): (() => void) => {
  const {
    data: { serviceToken },
  } = useContext(AuthContextFirebase);

  return () => {
    trackEvent('Setup.DownloadConfig', {
      platform: 'ios',
    });

    saveTextToFile(
      'bitrise_configuration.plist',
      'xml',
      `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
<dict>
    <key>APM_COLLECTOR_TOKEN</key>
    <string>${serviceToken}</string>
</dict>
</plist>
    `,
    );
  };
};

export default useDownloadConfigIOS;
